export enum RouteContext {
  NONE,
  SEARCH_BY_VEHICLE,
  PACKAGE_BUILDER,
  PRODUCTS_BY_SPEC,
  PRODUCTS_BY_BRAND,
  SEARCH_BY_TEXT,
  SEARCH_BY_VEHICLE_FOR_ACCESSORY,
  PRODUCTION_PROPOSAL_DETAILS,
  PRODUCTS_BY_TYPE
}
